import type { QueryClient } from "@tanstack/react-query";

import { orpc } from "@/utils/orpc.client";

export function invalidateFeedViews(queryClient: QueryClient) {
  return queryClient.invalidateQueries({ queryKey: orpc.feed.key() });
}

export async function invalidatePostViews(queryClient: QueryClient, postId: string) {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: orpc.posts.get.queryOptions({ input: { id: postId } }).queryKey,
    }),
    queryClient.invalidateQueries({
      queryKey: orpc.feed.feedEventByPostId.queryOptions({ input: { postId } }).queryKey,
    }),
    invalidateFeedViews(queryClient),
  ]);
}

export async function invalidateFeedEventComments(
  queryClient: QueryClient,
  targetType: "feed_event",
  targetId: string,
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["comments", targetType, targetId] }),
    invalidateFeedViews(queryClient),
  ]);
}
